import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { PageFrame } from '../../components/PageFrame';
import type { createLearnerSessionClient } from '../../platform/learner/learner-session-client';

type Props = {
  client: Pick<ReturnType<typeof createLearnerSessionClient>, 'resume'>;
  children: ReactNode;
};

export function RequireLearnerCapability({ client, children }: Props) {
  const [status, setStatus] = useState<'checking' | 'ready' | 'invalid'>(
    'checking',
  );
  useEffect(() => {
    let active = true;
    void client
      .resume()
      .then(() => {
        if (active) setStatus('ready');
      })
      .catch(() => {
        if (active) setStatus('invalid');
      });
    return () => {
      active = false;
    };
  }, [client]);

  if (status === 'invalid') return <Navigate to="/learn" replace />;
  if (status === 'checking') {
    return (
      <PageFrame title="Checking your session" audience="learner">
        <p role="status" className="mt-4">
          Checking your session…
        </p>
      </PageFrame>
    );
  }
  return <>{children}</>;
}
